export function singleSlashPath(path: string): string {
  if (!path) return "";
  // 只处理连续的多余斜杠，将其替换为单个斜杠
  // 但保留协议部分 (http:// 或 https://) 的双斜杠
  let normalized = path;

  // 如果是完整URL，先保护协议部分
  if (/^(https?:\/\/)/i.test(path)) {
    const protocol = path?.match(/^(https?:\/\/)/i)?.[0];
    const restPath = path.substring(protocol?.length || 0);
    // 对路径部分进行斜杠规范化
    const cleanRest = restPath.replace(/\/+/g, "/");
    normalized = protocol + cleanRest;
  } else {
    // 非HTTP路径，直接替换连续斜杠
    normalized = path.replace(/\/+/g, "/");
  }

  return normalized;
}
export function adaptToJsonFormat(inputStr) {
  try {
    // 使用正则表达式替换单引号为双引号
    let adaptedStr = inputStr
      .replace(/'/g, '"') // 替换所有单引号为双引号
      // .replace(/(\w+):/g, '"$1":'); // 确保键是用双引号包裹的
      .replace(/(\b\w+):/g, function (match, p1) {
        //如果是以 http 或 https 开头，不替换键
        if (p1 === 'http' || p1 === 'https') {
          return match // 保持不变
        }
        return '"' + p1 + '":' // 否则替换为 "键名":
      })
    // 尝试解析为JSON对象
    let jsonObj = JSON.parse(adaptedStr)
    return jsonObj
  } catch (error) {
    console.error('转换失败:', error)
    return null
  }
}
function isSupportWebp(): boolean {
  try {
    const img = document.createElement('canvas')
    const imgData = img.toDataURL('image/webp', 0.5)
    return imgData.indexOf('data:image/webp') === 0
  } catch (err) {
    return false
  }
}
const _isSupportWebp = isSupportWebp()

// 修改图片后缀为 .js 或 .w.js
export const changeImageSuffix = (path: string) => {
  if (!path) return path

  // 分离 query 参数
  const [urlWithoutQuery, query] = path.split('?')

  // 用正则匹配图片后缀
  const reg = /\.(jpg|jpeg|png|bmp|gif|tiff|webp)$/i

  let newUrl = urlWithoutQuery
  if (reg.test(urlWithoutQuery)) {
    // 如果支持 webp 且不是 gif，用 .w.js，否则用 .js
    if (_isSupportWebp && !/\.gif$/i.test(urlWithoutQuery)) {
      newUrl = urlWithoutQuery.replace(reg, '.w.js')
    } else {
      newUrl = urlWithoutQuery.replace(reg, '.js')
    }
  }

  return query ? `${newUrl}?${query}` : newUrl
}

//返回列表网速最快地址
export async function measureDomainSpeed(domainList = [], file = '') {
  console.log('[域名调试] measureDomainSpeed 开始测速, 域名列表:', domainList.map((d: any) => d?.url || d))
  return new Promise((resolve) => {
    const controller = new AbortController()
    const signal = controller.signal
    const timeout = 1000 * 8 //超时时间
    //超时随机取一个
    const rIdx = Math.floor(Math.random() * domainList?.length)
    let fail = 0
    //是否全部请求完成
    const inter = setInterval(() => {
      if (fail == domainList?.length) {
        console.log('[域名调试] measureDomainSpeed 所有请求失败，随机选择索引:', rIdx, '域名:', (domainList[rIdx] as any)?.url || domainList[rIdx])
        resolveFn(domainList[rIdx])
      }
    }, 300)
    //返回数据
    function resolveFn(data) {
      console.log('[域名调试] measureDomainSpeed 最终选定域名:', (data as any)?.url || data)
      resolve(data)
      controller.abort() // 中断请求
      clearInterval(inter) //清除定时器
      clearTimeout(timer) //清除定时器
    }
    //超时随机取一个
    const timer = setTimeout(() => {
      console.log('[域名调试] measureDomainSpeed 超时，随机选择索引:', rIdx, '域名:', (domainList[rIdx] as any)?.url || domainList[rIdx])
      resolveFn(domainList[rIdx])
    }, timeout)
    //请求数据
    function useFetch(url, item) {
      const startTime = performance.now() // 获取开始时间
      fetch(singleSlashPath(url), {
        method: 'HEAD', // 指定使用 HEAD 请求
        cache: 'no-store',
        mode: 'cors',
        signal
      })
        .then(() => {
          const endTime = performance.now() // 获取结束时间
          const duration = endTime - startTime // 计算耗时
          const name: string = item.url ? item.url : item
          window[name] = duration.toFixed(2)
          console.log('[域名调试] measureDomainSpeed 域名响应:', { url: item?.url || item, duration: duration.toFixed(2) + 'ms' })
          resolveFn(item)
        })
        .catch((error) => {
          fail += 1
          console.log('[域名调试] measureDomainSpeed 域名失败:', { url: item?.url || item, fail, total: domainList?.length, error: error.name })
          if (error.name === 'AbortError') {
            console.log('Fetch aborted due to timeout')
          } else {
            console.error('Error:', error)
          }
        })
    }
    if (!domainList || !domainList.length) {
      resolveFn('')
      return
    }
    domainList?.map(async (item) => {
      if (typeof item == 'object') {
        const url = item.url + (file ? file : '')
        useFetch(url, item)
      } else {
        const url = item + (file ? file : '')
        useFetch(url, item)
      }
    })
  })
}

export async function checkM3U8UrlWithTimeout(url, timeout = 5000) {
  // 5秒超时时间
  const controller = new AbortController()
  const { signal } = controller
  setTimeout(() => controller.abort(), timeout) // 设置超时时间后中断请求
  try {
    const response = await fetch(singleSlashPath(url), { signal })
    if (response.ok) {
      return true
    } else {
      console.log('m3u8地址不可用，状态码:', response.status)
      return false
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      console.log('请求超时')
    } else {
      console.error('请求m3u8地址时出错:', error)
    }
    return false
  }
}
